import { render, staticRenderFns } from "./CoverholderReport.vue?vue&type=template&id=5beb7359&"
import script from "./CoverholderReport.vue?vue&type=script&lang=js&"
export * from "./CoverholderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports